import { ChangeUserPassDto } from './../../../models/dto/change-user-pass.dto';
import { HttpService } from './../../../Services/http.service';
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../../../constants';
import { matchValues } from '../../../validators/matchvalues.validator';
import {testPassStrength} from "../../../helpers/passwordStrength";


@Component({
  selector: 'app-pass-changes-modal',
  templateUrl: './pass-changes-modal.component.html',
  styleUrls: ['./pass-changes-modal.component.css']
})
export class PassChangesModalComponent implements OnInit {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  @Output() result = new EventEmitter<boolean>();
  form: UntypedFormGroup;
  password: string;
  passStrength: number;
  modalReference: NgbModalRef;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'sm'
  };

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private httpService: HttpService) {

    this.form = this.fb.group({
      oldPassword: ['', Validators.required],
      password: ['', [Validators.required, Validators.maxLength(Constants.maxPassLength), Validators.pattern(Constants.passRegex)]],
      passwordConfirm: ['', [Validators.required, matchValues('password')]]
    });
  }

  ngOnInit() {
    this.form.controls['password'].valueChanges.subscribe(() => {
      this.form.controls['passwordConfirm'].updateValueAndValidity();
      this.password = this.form.controls['password'].value;
      this.passStrength = testPassStrength(this.password);
    });
  }

  open() {
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
  }

  get passControl() {
    return this.form.controls['password'];
  }

  get oldPassControl() {
    return this.form.controls['oldPassword'];
  }

  get confirmPassControl() {
    return this.form.controls['passwordConfirm'];
  }

  async save() {
    this.form.markAllAsTouched();
    if (this.form.invalid) { return; }
    const changePassDto = new ChangeUserPassDto();
    changePassDto.oldPassword = this.oldPassControl.value;
    changePassDto.password = this.passControl.value;
    changePassDto.confirmPassword = this.confirmPassControl.value;
    try {
      await this.httpService.changePassword(changePassDto).toPromise();
      this.result.emit(true)
    }
    catch {
      this.result.emit(false);
    }
    finally {
      this.closeModal();
    }
  }

  closeModal() {
    this.form.reset();
    this.modalReference.close();
  }
}
